import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/profile-card-item/profile-card-item.styles.ts
var profile_card_item_styles_default = r` ${component_styles_default} .profile-card-item { line-height: 0; padding-bottom: 0.375rem; } .profile-card-item--last-child { padding-bottom: 0; } .profile-card-item--value { margin-left: var(--sl-spacing-2x-small); } `;

export {
  profile_card_item_styles_default
};
